export default "__VITE_ASSET__CtpCNbag__"